import { gql, type OperationVariables } from '@apollo/client';

import GraphQL from '../graphQL';

const q = gql`
query getUploadURLCompanyLogo($themeMode: String!) {
    getUploadURLCompanyLogo(themeMode: $themeMode)
    {
        id
        url
        fields
    }
},
`;

/**
 * Returns the upload URL for a company logo.
 *
 * @param themeMode - The theme mode for the logo ('light' or 'dark')
 * @returns A promise that resolves to upload data.
 */
export default function getUploadURLCompanyLogo(themeMode: 'light' | 'dark' = 'light') {
    const variables: OperationVariables = { themeMode };
    return GraphQL.query<{ getUploadURLCompanyLogo: IUploadData }>(q, variables).then((data) => {
        return data.getUploadURLCompanyLogo;
    });
}

interface IUploadData {
    id: string;
    url: string;
    fields: {
        [key: string]: string;
    };
}
